import React from "react";
import Heading from "../Heading";
import { Box } from "@mui/material";
import { BannerStyles } from "../Styles";
import { getMeaning } from "../../utils/localization";
import GlobalSubHeading from "../GlobalSubHeading";

const Banner = () => {
  return (
    <Box sx={[BannerStyles.mainbannerBox, { mt: { xs: -6, sm: -6, md: -2 } }]}>
      <Heading title={getMeaning("HME.HGNG")} />

      <Box align="center">
        <GlobalSubHeading subTitle={getMeaning("HME.SBHGNG1")} />
      </Box>

      <Box
        sx={[
          BannerStyles.bannerBox,
          { height: { xs: "25vh", sm: "25vh", md: "70vh", lg: "70vh" } },
        ]}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            height: "auto",
            width: "95%",
            // border: "1px solid #cfd8dc",
          }}
        >
          <source
            src={require("../../assets/video/HomeVideoNew.mp4")}
            type="video/mp4"
            width={"90%"}
          />
        </video>
      </Box>
    </Box>
  );
};

export default Banner;
